"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmCaption = void 0;
/* eslint-disable react/require-default-props */
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../Icon");
const iconMap = {
    error: (react_1.default.createElement(Icon_1.SmIcon, { type: "outlined", name: "error_outline", size: "small", "data-testid": "test-error-icon" })),
    success: (react_1.default.createElement(Icon_1.SmIcon, { type: "outlined", name: "check_circle", size: "small", "data-testid": "test-success-icon" })),
    default: (react_1.default.createElement(Icon_1.SmIcon, { type: "outlined", name: "info", size: "small", "data-testid": "test-success-icon" })),
};
const SmCaption = ({ id, message, state }) => {
    if (!message) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement("small", { id: `${id}-description`, className: "c-field__description", "data-testid": "test-icon-container" },
        iconMap[state],
        message));
};
exports.SmCaption = SmCaption;
//# sourceMappingURL=caption.js.map